/**
 * ko-countdown.js
 * -------------
 * Minimal, dependency-free countdown with Shopify Customizer support.
 */
(function () {
  "use strict";

  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function formatRemaining(msRemaining) {
    if (msRemaining <= 0) return "00:00:00:00";
    var totalSeconds = Math.floor(msRemaining / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    return pad(days) + ":" + pad(hours) + ":" + pad(minutes) + ":" + pad(seconds);
  }

  function initCountdown(el) {
    var targetIso = el.getAttribute("data-countdown-target");
    if (!targetIso) return;

    var targetDate = new Date(targetIso);
    if (isNaN(targetDate.getTime())) {
      return;
    }

    var timerEl = el.querySelector(".ko-countdown__timer");
    if (!timerEl) return;

    function tick() {
      var remaining = targetDate.getTime() - Date.now();
      timerEl.textContent = formatRemaining(remaining);
      if (remaining <= 0) {
        clearInterval(intervalId);
        el.dispatchEvent(new CustomEvent("drop:ended"));
      }
    }

    tick();
    var intervalId = setInterval(tick, 1000);
  }

  // Runs on a fresh page load
  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll(".ko-countdown")
      .forEach(initCountdown);
  });

  // Runs instantly inside the Customizer when a setting changes
  document.addEventListener("shopify:section:load", function (e) {
    e.target.querySelectorAll(".ko-countdown").forEach(initCountdown);
  });
})();